import "./DataFrame.css";
type Props = {
  className?: string;
  children: React.ReactNode;
};

export default function DataFrame({ children, className }: Props) {
  return (
    <div className={"data-frame " + className}>
      <div className="data-frame-content">{children}</div>
    </div>
  );
}
